export enum OperationLOSEnum {
    LOS_UNKNOWN = 'LOS_UNKNOWN',
    LOS_VLOS = 'LOS_VLOS',
    LOS_EVLOS = 'LOS_EVLOS',
    LOS_BVLOS = 'LOS_BVLOS',
}